import * as Flowbite from 'flowbite-react';
import type { ComponentProps } from 'react';

type FlowbiteSpinnerProps = Pick<Flowbite.SpinnerProps, 'color' | 'size'>;

type SpinnerProps = FlowbiteSpinnerProps & Omit<ComponentProps<'span'>, 'ref'>;

export const Spinner = (props: SpinnerProps) => (
    <Flowbite.Spinner data-testid="spinner" {...props} />
);
